const es = {
    views: {
        home: {
            repositoryName: 'Nombre del repositorio',
            search: 'Buscar',
            title: 'Azertiumit ejercicio',
        },
    },
};

export default es;
